import React from 'react'
import './Loader.scss';
import companyLogoImg from "../../assets/images/PFLogoSmall.png";

const Loader = () => {
  return (
    <div id="no-freeze-loader" >
      <div class="svg-container">
        <svg xmlns="http://www.w3.org/2000/svg" class="svg" viewBox="0 0 512 512" preserveAspectRatio="xMinYMin meet">
          <path class="symbol" d="M256.2 2.9c36.8 0 52.4 23.9 77.2 32 24.8 8.1 41.8-5.2 71.6 16.4 29.8 21.6 28.3 50.1 43.7 71.2 15.3 21.1 36.9 20.4 48.2 55.4 11.4 35-6.5 57.2-6.5 83.3 0 26.1 17.9 38.1 6.5 73.1-11.4 35-38.9 42.4-54.2 63.5-15.3 21.1-8 41.3-37.7 63-29.8 21.6-56.4 11.5-81.2 19.5-24.8 8.1-30.8 28.8-67.6 28.8s-52.4-23.9-77.2-32c-24.8-8.1-41.8 5.2-71.6-16.4C77.5 439 79 410.5 63.6 389.4S26.7 369 15.4 334c-11.4-35 6.5-57.2 6.5-83.3 0-26.1-17.9-38.1-6.5-73.1 11.4-35 38.9-42.4 54.2-63.5 15.3-21.1 8-41.4 37.7-63s56.4-11.5 81.2-19.5c24.9-8 30.9-28.7 67.7-28.7z" />
        </svg>
        <img src={companyLogoImg}></img>
      </div>
    </div>
  )
}

export default Loader